var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-aspect',{attrs:{"aspect":_vm.aspect}},[_c('div',{staticClass:"h-100 position-relative overflow-hidden"},[_c('div',{style:({ height: 0 })},[_vm._t("default")],2),_vm._t("relative")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }